module.exports = __webpack_public_path__ + "static/media/mobile.de509282.svg";